import { Card, Label, Modal, RenderControl } from '@fareye/ui'
import React, { useEffect } from 'react'
import {
  DEVICE_CONFIG,
  HEADER_INFLECTION,
  initialState
} from '../../../config/constants'
import { get, cancelToken, isEmpty } from '@fareye/utils'
import DeviceTable from './DeviceTable'

export default function HistoryModal({
  selectedDevice,
  setSelectedDevice
}: any) {
  const [deviceHistory, setDeviceHistory] = React.useState(initialState)
  const { deviceHistoryPathParam } = DEVICE_CONFIG
  const source = cancelToken().source()

  useEffect(() => {
    fetchDevices()
  }, [])

  const fetchDevices = async () => {
    try {
      setDeviceHistory({ ...deviceHistory, isLoading: true })
      const url = `${deviceHistoryPathParam}?imei=${selectedDevice?.data?.imei}`
      const {
        data: { data }
      } = await get(url, source.token, HEADER_INFLECTION)
      setDeviceHistory({
        ...deviceHistory,
        data,
        isLoading: false,
        isSuccess: true,
        isError: false,
        message: isEmpty(data) ? 'No Data Found' : ''
      })
    } catch (ex) {
      setDeviceHistory({
        ...deviceHistory,
        isLoading: false,
        isSuccess: false,
        isError: true,
        message: 'Something went wrong'
      })
      console.error(ex)
    }
  }
  const CardHeader = () => {
    return (
      <Label style={{ padding: '10px 15px' }} variant="h5">
        History for IMEI NO- {selectedDevice?.data?.imei}
      </Label>
    )
  }

  return (
    <Modal
      variant="m drawer Top-Right"
      toggleModal={selectedDevice.openHistoryModal}
      style={{ content: { height: '100%', maxHeight: '100vh' } }}
      setToggleModal={openHistoryModal => {
        setSelectedDevice({
          ...selectedDevice,
          openHistoryModal
        })
      }}
    >
      <Card header={CardHeader()}>
        <RenderControl state={deviceHistory}>
          <DeviceTable
            setSelectedDevice={setSelectedDevice}
            deviceData={deviceHistory}
            hideAction={true}
            meta={{
              count: deviceHistory.data.length,
              perPage: deviceHistory.data.length
            }}
            key="history-table"
          />
        </RenderControl>
      </Card>
    </Modal>
  )
}
